import { z } from "zod";
/**
 * Storage proxy endpoints respond with a 302 redirect to a presigned MinIO URL.
 * No structured response body. This module exports a placeholder schema so the
 * route handlers can declare a response shape for OpenAPI documentation.
 */
export const storageRedirectInfo = z.object({
    url: z.string().url(),
});
/**
 * Response for `POST /api/v2/storage/images` — a one-shot "store these bytes
 * and hand me back a fetchable link".
 *
 * `url` is a presigned GET, so it EXPIRES. It is intended for a consumer that
 * downloads immediately (the vision service handing a crop to an external
 * system). Anything that persists the link and fetches later will break once
 * `expiresAt` passes — store `objectKey` instead and re-presign on demand.
 */
export const uploadImageResponse = z.object({
    /** Content hash of the stored bytes. Uploads are idempotent on this. */
    sha256: z.string(),
    /** Durable storage key. Survives URL expiry — persist this, not `url`. */
    objectKey: z.string(),
    /** Presigned GET URL, valid until `expiresAt`. */
    url: z.string().url(),
    /** ISO-8601 instant at which `url` stops working. */
    expiresAt: z.string().datetime(),
    /** Seconds of validity granted (may be lower than requested — it is capped). */
    ttlSeconds: z.number().int().positive(),
});
//# sourceMappingURL=storage.schemas.js.map